<!--阅读拓展馆-->
<template>
    <div class="read_nav_content">
        <!-- 阅读拓展首页 -->
        <div class="read-ext-container" v-show="showMode==='homePage'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">恒岳·劳动实践营</div>
                    <div class="l-b-museum-title-container">习得劳动技能 培养责任担当</div>
                </div>
                <div class="r-museum-title-container">
                    <div v-show="this.isShowBack" class="back-btn-container" @click="backMuseum" >⇦返回</div>
                </div>

            </div>
            <div class="museum-item-container">
                <div class="labor-museum-item-line-container">
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">一年级 芽手初萌•指尖启智</div>
                                <div class="museum-item-20 labor-mf2">从生活小物入手，唤醒动手意识，建立劳动兴趣</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('1','一年级 芽手初萌•指尖启智')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">二年级 叶技渐长•巧思匠作</div>
                                <div class="museum-item-20 labor-mf2">掌握基础手工技艺，培养耐心与专注力，初步接触传统工艺</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('2','二年级 叶技渐长•巧思匠作')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">三年级 花艺巧思•匠心造物</div>
                                <div class="museum-item-20 labor-mf2">融合传统美学与创意表达，锤炼精细手工能力，感受非遗韵味</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('3','三年级 花艺巧思•匠心造物')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 第二行  -->
                <div class="labor2-museum-item-line-container">
                    <div class="museum-item-top2-container">
                        <div class="labor2-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">四年级 实能扎根•知行砺志</div>
                                <div class="museum-item-20 labor-mf2">强化综合实践与生活应用，结合农艺、编织、非遗技艺，培养责任意识</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('4','四年级 实能扎根•知行砺志')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top2-container">
                        <div class="labor2-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">五年级 创果丰实•智趣融合</div>
                                <div class="museum-item-20 labor-mf2">以项目式创作为核心，整合多类工艺，锻炼设计与解决问题的能力</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('5','五年级 创果丰实•智趣融合')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top2-container">
                        <div class="labor2-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">六年级 合耕致远•非遗传承</div>
                                <div class="museum-item-20 labor-mf2">跨领域协作，致敬非遗文化，完成综合性作品，实现从“做”到“传”的升华</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewPracticePage('6','六年级 合耕致远•非遗传承')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="labor-museum-item-bottom-container">
                    <div class="labor-museum-item-bottom-outside">
                        <div class="museum-item-bottom-inside">
                            <div class="museum-item-bottom-inside-l">
                                <div class="museum-item-60 mf1">劳动实践营</div>
                                <div class="museum-item-40 mf2">劳动实践主题班会</div>
                            </div>
                            <div class="museum-item-bottom-inside-r dis-align">
                                <div class="inside-r-btn" @click="viewPageEvent('劳动实践主题班会','4')">查看线下活动</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--劳动实践活动-->
        <div class="practice-page-container" v-show="showMode==='practicePage'">
            <practice-page-home :item-key="this.itemKey"
                                :item-name="this.itemName"
                                :mark-info="this.markInfo"
                                @back-practice-page="backModelPage"/>
        </div>

        <!--研学实践-->
        <div class="read_nav_content" v-show="showMode==='museumEventPage'">
            <labor-event-club :museum-id="this.museumId"
                               :mark-info="this.markInfo"
                               @back-read-museum="backModelPage"/>
        </div>

    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import beautyEdu from "@/components/newMuseum/read/beautyEdu.vue";
import pageMuseumEvent from "@/components/newMuseum/event/pageMuseumEvent.vue";
import practiceHome from "@/components/newMuseum/practice/practiceHome.vue";
import practicePageHome from "@/components/newMuseum/practice/practicePageHome.vue";
import laborEventClub from "@/components/museumEvent/laborEventClub.vue";

export default {
    name: "laborPracticeMuseum",
    components: {practicePageHome, laborEventClub, pageMuseumEvent, beautyEdu,practiceHome},
    data() {
        return {
            showMode:'homePage',
            baseMode:'model-',
            serviceUrl,
            itemId:'',
            itemName:'恒岳科创会',
            markInfo:'museumEventPage',
            museumMode:"",
            museumId:"",
            itemKey:"",
        }
    },
    computed: {},
    props:{
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        isShowBack(newValue,oldValue){
        },
    },
    created() {
    },
    mounted(){},
    methods: {
        backModelPage(val){
            this.showMode = "homePage";
        },
        viewPageEvent(title,key){
            this.markInfo = new Date();
            this.museumId = '4';
            this.showMode = 'museumEventPage';
        },
        viewPracticePage(val,name){
            this.itemKey = val;
            this.itemName = name;
            this.markInfo = new Date();
            this.showMode="practicePage";
        },
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        /*查看阅读馆模块*/
        viewReadModel(val){
            this.markInfo = 'time-'+new Date();
            this.showMode =  this.baseMode+val;
        },
        /*从子模块阅读馆*/
        backReadMuseum(val){
            this.showMode = val;
        }
    }
}
</script>
<style scoped>
.read_nav_content{
    width: 100%;
    height: auto;
}
.read-ext-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}

.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.museum-item-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.labor-museum-item-line-container{
    width: 100%;
    height: 35%;
    display: flex;
    gap: 20px;
}
.labor2-museum-item-line-container{
    width: 100%;
    height: 35%;
    display: flex;
    gap: 20px;
}
.museum-item-top-container{
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.museum-item-top2-container{
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.labor-museum-item-top{
    width: 100%;
    height: 85%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    //box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.labor2-museum-item-top{
    width: 100%;
    height: 85%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    //box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.museum-item-60{
    width: 100%;
    height: 60%;
}
.mf1{
    color: #0d55a4;
    //font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.labor-mf2{
    color: #9a9a9a;
    font-size: 13px;
}

.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}

.labor-museum-item-bottom-container{
    width: 100%;
    height: 30%;
}
.labor-museum-item-bottom-outside{
    width: 100%;
    height: 70%;
    border: 3px solid #0d55a4;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-bottom-inside{
    width: 99%;
    height: 92%;
    border: 1px solid #e99d42;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}

.museum-item-bottom-inside-l{
    width: calc(100% - 120px);
    height: 100%;
}
.museum-item-bottom-inside-r{
    width: 120px;
    height: 100%;
}
.inside-r-btn{
    width: 100%;
    height: 38%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}

</style>